// extracted by mini-css-extract-plugin
var _1 = "RosteringReview__button--n9Cav SchoolGeneral__button--ZIm36";
var _2 = "RosteringReview__main--tCQct";
var _3 = "RosteringReview__nextYearAlert--fsbB0";
var _4 = "RosteringReview__processingError--ebEU9";
var _5 = "RosteringReview__processingFailure--qFJW9";
var _6 = "RosteringReview__processingResult--pNMmT";
var _7 = "RosteringReview__processingSuccess--PXXuV";
var _8 = "RosteringReview__statusText--CJmQG";
var _9 = "RosteringReview__summaryItem--_GS8U";
var _a = "RosteringReview__summaryList--m3ZLp";
export { _1 as "button", _2 as "main", _3 as "nextYearAlert", _4 as "processingError", _5 as "processingFailure", _6 as "processingResult", _7 as "processingSuccess", _8 as "statusText", _9 as "summaryItem", _a as "summaryList" }
